import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

export const usePayrixStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      marginTop: theme.spacing(1)
    },
    inputLabel: {
      marginBottom: '5px'
    },
    inputTooltipBadge: {
      position: 'absolute',
      left: 56,
      right: 'unset',
      marginTop: -3
    },
    payField: {
      height: 91,
      overflow: 'hidden'
    },
    zipInput: {
      textTransform: 'uppercase'
    },
    zipInputErrorRoot: {
      borderColor: 'red' // payrix error color
    }
  }),
  { name: 'PayrixPaymentDialog' }
)
